import {IS_DEV} from '@src/config.ts';
import {setMosaicSlice} from '@src/stores/mosaicsSlice.ts';
import {CombinedState} from '@src/stores/types.ts';
import merge from 'lodash/merge';
import {create} from 'zustand';
import {devtools, persist, createJSONStorage} from 'zustand/middleware';
import {immer} from 'zustand/middleware/immer';
import {setMapSlice} from './mapSlice.ts';

export const useStore = create<CombinedState>()(
  devtools(
    persist(
      immer((set, get, store) => ({
        map: setMapSlice(set, get, store),
        mosaics: setMosaicSlice(set, get, store),
        reset: () => {
          set(store.getInitialState());
        },
      })),
      {
        name: 'pl-insights-data-app',
        storage: createJSONStorage(() => sessionStorage),
        partialize: state => ({
          map: {
            feature: state.map.feature,
            centerMarkerCoord: state.map.centerMarkerCoord,
          },
        }),
        merge: (persistedState, currentState) =>
          merge(currentState, persistedState),
      },
    ),
    {name: 'acornsStore'},
  ),
);

// If you don't have the Redux DevTools Chrome extension installed,
// useStore.devtools will be undefined
if (IS_DEV && useStore.devtools) {
  useStore.devtools.cleanup();
}
